import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { NavComponent } from 'src/app/traits/nav/nav.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-setup-branch',
  templateUrl: './setup-branch.component.html',
  styleUrls: ['./setup-branch.component.css']
})
export class SetupBranchComponent implements OnInit {
  add: Boolean; edit: Boolean; ch:any; channels: any[] = []; response: any; user: any; merchants: any[] = [];
  status = ['Active', 'Inactive'];

  listView() {
    this.add = true; this.edit = false;
  }

  back() {
    this.add = false;
  }

  constructor(private api: ApiService, private use: NavComponent) { }

  ngOnInit() {
    this.user = this.use.active;
    this.init();
    if(this.use.active.typ ==="Admin" || this.use.active.typ === "Support") {
      this.getMerchant();
    }
  }

  getMerchant() {
    this.api.get('merchant?limit=100').subscribe((data: any) => {
      this.merchants = data.data;
    }, (err: HttpErrorResponse) => {
      this.use.showMsg('error', 'Fetching Fail', 'Unable to Fetch Merchant List');
    });
  }

  SaveChanel() {
    if(this.ch.apikeyid > 0) {
      this.putChannel();
    } else {
      this.postChannel();
    }
  }
  
  postChannel() {
    this.api.post('apikey',this.ch).subscribe((data: any) => {
      this.init();
      this.use.showMsg('success', 'Channel Added', 'Added to list Successfully');
    }, (err: HttpErrorResponse) => {
      this.use.showMsg('error', 'Adding Fail', 'Unable to Add New Channel');
    });
  }

  putChannel() {
    this.api.put('apikey/', this.ch).subscribe((data: any) => {
      this.init();
      this.use.showMsg('success', 'Channel Updated', 'Details Updated Successfully');
    }, (err: HttpErrorResponse) => {
      this.use.showMsg('error', 'Updated Fail', 'Unable to Update Details');
    });
  }

  init() {
    this.ch = { apikeyid: 0, name: '', appid: '', key: '', reference: '', active: true, merchantid: "", }
  }

}







